import { useState } from "react";
import styled from "styled-components";
import { useAsset } from "../../../hooks/useAsset";
import { FavoriteIcon } from "../../atoms/FavoriteIcon";

type Props = {
  id?: number;
  imageUrl: string;
  isFavorite: boolean;
  onFavorite: (favorite: boolean) => void;
  onClickImage: () => void;
  width?: number;
  height?: number;
};

export const MenuImage: React.FC<Props> = ({
  id,
  imageUrl,
  isFavorite,
  onFavorite,
  onClickImage,
  width,
  height,
}) => {
  const { baseDir } = useAsset();

  const [hasLoaded, setHasLoaded] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);

  return (
    <MenuImageContainer>
      <StyledImage
        id={`menu-image-${id}`}
        src={
          imageUrl && hasLoaded && !hasError
            ? imageUrl
            : baseDir + "/assets/images/menu_dummy@2x.jpg"
        }
        alt="menu"
        width={width}
        height={height}
        onClick={onClickImage}
        onLoad={() => setHasLoaded(true)}
        onError={() => setHasError(true)}
      />

      <FavoriteIconContainer
        data-testid="menu-image-like"
        id={`menu-image-like-container-${id}`}
      >
        <FavoriteIcon
          id={id}
          data-testid="menu-image-like"
          type="heart"
          favorite={isFavorite}
          onClick={onFavorite}
        />
      </FavoriteIconContainer>
    </MenuImageContainer>
  );
};

const MenuImageContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

const FavoriteIconContainer = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
`;

const StyledImage = styled.img<{ width?: number; height?: number }>`
  object-fit: cover;
  width: ${({ width }) => (width ? `${width}px` : "100%")};
  height: ${({ height }) => (height ? `${height}px` : "auto")};
  aspect-ratio: 1;
`;
